import {
  GET_CART_API_REQUEST,
  GET_CART_API_SUCCESS,
  GET_CART_API_ERROR,
} from '../../../constants/cartActionNames';
import { checkCacheValid, generateCacheKey } from '../../../utils/functions/cache';
import { getCartUrl } from '../../../apis/cart/cartApi';
import { cartApi } from '../../../apis/cart';

function getCartRequest() {
  return {
    type: GET_CART_API_REQUEST,
    payload: true,
  };
}

function getCartSuccess(cart, params, cacheKey) {
  return {
    type: GET_CART_API_SUCCESS,
    payload: cart,
    params,
    cacheKey,
  };
}

function getCartError(err) {
  return {
    type: GET_CART_API_ERROR,
    payload: err,
  };
}

export function getCartAction(params) {
  return (dispatch, getState) => {
    const state = getState();

    const alpha2 = state?.locations?.yourLocation?.alpha2;
    params.alpha2 = alpha2;

    const cacheKey = generateCacheKey({
      path: getCartUrl,
      cacheParams: params,
    });

    const { isCacheValid } = checkCacheValid(getState, 'cart', cacheKey);
    if (isCacheValid) {
      // console.log('isCacheValid: ', isCacheValid);
      // dispatch(getClaimsSuccess(null, params, cacheKey, filteredLobCategories));
      return Promise.resolve(null);
    }

    // console.log(state);
    dispatch(getCartRequest());
    return cartApi
      .getCart(state, params)
      .then(data => {
        dispatch(getCartSuccess(data, params, cacheKey));
        return data;
      })
      .catch(error => {
        dispatch(getCartError(error));
        throw error;
      });
  };
}

export default { getCartAction };
